// This site's own canonical origin, used for <link rel="canonical"> and
// Open Graph/Twitter og:url tags (see components/Seo.jsx). Keyed by
// VITE_STAGING the same way appUrl.js keys the FlipAd app's origin — see
// that file's comment for why VITE_STAGING is already correct here for free.
// Site IDs for development/uat come from .firebaserc's "website" hosting
// target; production is the custom domain attached on top of flipad-website's
// default *.web.app URL.
const STAGING = import.meta.env.VITE_STAGING;

const SITE_URL_BY_STAGING = {
  local: 'http://localhost:5174', // matches vite.config.js's dev server port
  development: 'https://flipad-website-dev.web.app',
  uat: 'https://flipad-website-uat.web.app',
  production: 'https://flipad.in',
};

const SITE_URL = (SITE_URL_BY_STAGING[STAGING] || 'http://localhost:5174').replace(/\/$/, '');

export function siteUrl(path = '') {
  return `${SITE_URL}${path}`;
}
